import { EMBED_PLATFORM_LIST } from 'constants/constants';
import { getUrlParamByKey } from 'utils/urlParams';

/**
 * It checks if the current page is embedded into a platform by checking the URL parameter `embed`
 * @returns A boolean value.
 */
export const isEmbedIntoPlatform = () => {
    const embedPlatformName = getUrlParamByKey('embed');
    const result = EMBED_PLATFORM_LIST.some((item) => item === embedPlatformName);
    return result;
};
